import React from 'react';

/**
 * TrésoPilot wordmark styled like the email templates:
 * - "Tréso" in #304050
 * - "Pilot" in #00A080
 *
 * Keeps the app font (Inter/system stack) and is safe to use everywhere.
 */
export default function Wordmark({ size = 'default', variant = 'default', className = '' }) {
  const sizes = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-3xl',
  };

  const textSize = sizes[size] || sizes.default;

  const tresoClass = variant === 'light' ? 'text-white' : 'text-[#304050]';
  // On dark backgrounds, keep "Pilot" readable but still in the brand family.
  const pilotClass = variant === 'light' ? 'text-emerald-200' : 'text-[#00A080]';

  return (
    <span
      className={[
        textSize,
        'font-extrabold',
        'leading-none',
        'tracking-[-0.02em]',
        className,
      ].join(' ')}
    >
      <span className={tresoClass}>Tréso</span>
      <span className={pilotClass}>Pilot</span>
    </span>
  );
}
